import { UserService } from './service/user.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdmRoutingModule } from './adm-routing.module';
import { NewFormComponent } from './form/new-form/new-form.component';
import { ListFormComponent } from './form/list-form/list-form.component';
import { ListFormuleFormComponent } from './form/formule-form/list-formule-form/list-formule-form.component';
import { NewFormuleFormComponent } from './form/formule-form/new-formule-form/new-formule-form.component';
import { AngularmaterialModule } from 'src/app/modules/angular-material-module';
import { HomeComponent } from './home/home.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ListUsersComponent } from './users/list-users/list-users.component';
import { NewUserComponent } from './users/new-user/new-user.component';
import { ListPc003Component } from './pc003/list-pc003/list-pc003.component';
import { Pc003Service } from './service/pc003.service';
import { ListPc003EstrategiaComponent } from './pc003/list-pc003-estrategia/list-pc003-estrategia.component';
import { FilterPc003EstrategiaComponent } from './pc003/list-pc003-estrategia/filter-pc003-estrategia/filter-pc003-estrategia.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { ModalCommentPc003Component } from './pc003/list-pc003-estrategia/modal-comment-pc003/modal-comment-pc003.component';
import { FormPc003Component } from './pc003/new-pc003/pc003.component';
import { Pc003CardIComponent } from './pc003/new-pc003/partialViews/pc003-card-I.component';
import { ImportPc003ModalComponent } from 'src/app/shared/import-pc003/import-pc003.component';
import { Pc003FilterComponent } from './pc003/list-pc003/pc003-filter.component';
import { ListhumidityComponent } from './humidity/list-humidity/list-humidity.component';
import { HumidityService } from './service/humidity.service';
import { HumidityFilterComponent } from './humidity/list-humidity/humidity-filter.component';
import { HumidityCardIComponent } from './humidity/new-humidity/partialViews/humidity-card-I.component';
import { FormHumidityComponent } from './humidity/new-humidity/humidity.component';
import { ImportHumidityModalComponent } from 'src/app/shared/import-humidity/import-humidity.component';



@NgModule({
  declarations: [
    NewFormComponent,
    ListFormComponent,
    ListFormuleFormComponent,
    NewFormuleFormComponent,
    NewUserComponent,
    ListUsersComponent,
    HomeComponent,
    ListPc003Component,
    ListPc003EstrategiaComponent,
    FilterPc003EstrategiaComponent,
    ModalCommentPc003Component,
    FormPc003Component,
    Pc003CardIComponent,
    ImportPc003ModalComponent,
    Pc003FilterComponent,
    ListhumidityComponent,
    HumidityFilterComponent,
    FormHumidityComponent,
    HumidityCardIComponent,
    ImportHumidityModalComponent
  ],
  imports: [
    CommonModule,
    AdmRoutingModule,
    AngularmaterialModule,
    CKEditorModule,
    SharedModule
  ],
  providers: [
    UserService,
    Pc003Service,
    HumidityService
  ],
})
export class AdmModule { }
